__turbopack_context__.v({
  "body": "FilterSection-module-scss-module__nkF5vq__body",
  "description": "FilterSection-module-scss-module__nkF5vq__description",
  "header": "FilterSection-module-scss-module__nkF5vq__header",
  "root": "FilterSection-module-scss-module__nkF5vq__root",
});
